import { defineMessages } from 'react-intl';

import Edit from './PublicConsultationsListingEdit';
import View from './PublicConsultationsListingView';
import { publicConsultationsListingSchema } from './schema';

import iconSVG from '@plone/volto/icons/list-bullet.svg';

defineMessages({
  cards: {
    id: 'Public consultations listing',
    defaultMessage: 'Public consultations listing',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.publicConsultationsListingBlock = {
    id: 'publicConsultationsListingBlock',
    title: 'Public consultations listing',
    group: 'govbr',
    icon: iconSVG,
    view: View,
    edit: Edit,
    blockSchema: publicConsultationsListingSchema,
    restricted: false,
    sidebarTab: 1,
    mostUsed: false,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
